/**
 * <explore-gifts> — sections/explore-gifts.liquid
 */
(function () {
  if (customElements.get("explore-gifts")) return;

  const MOBILE_QUERY = "(max-width: 749px)";
  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  class ExploreGifts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector(".egc_grid");
      this.items = Array.from(this.querySelectorAll(".egc_item"));

      if (!this.items.length) return;

      this.mobileQuery = window.matchMedia(MOBILE_QUERY);
      this.reducedMotionQuery = window.matchMedia(REDUCED_MOTION_QUERY);

      this.onKeydown = this.onKeydown.bind(this);
      this.syncTrackFocus = this.syncTrackFocus.bind(this);

      this.setupReveal();
      this.setupSlider();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.track) this.track.removeEventListener("keydown", this.onKeydown);
      if (this.mobileQuery) this.mobileQuery.removeEventListener("change", this.syncTrackFocus);
    }

    
    setupReveal() {
      if (this.dataset.reveal !== "true") return;

      if (this.reducedMotionQuery.matches || !("IntersectionObserver" in window)) {
        this.items.forEach((item) => item.classList.add("is-in-view"));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-in-view");
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0.15 },
      );

      this.items.forEach((item) => this.observer.observe(item));
    }

   
    setupSlider() {
      if (!this.track) return;

      this.track.addEventListener("keydown", this.onKeydown);
      this.mobileQuery.addEventListener("change", this.syncTrackFocus);
      this.syncTrackFocus();
    }

    syncTrackFocus() {
      if (!this.track) return;

      if (this.mobileQuery.matches) {
        this.track.setAttribute("tabindex", "0");
        this.track.setAttribute("aria-label", this.trackLabel);
      } else {
        this.track.removeAttribute("tabindex");
        this.track.removeAttribute("aria-label");
      }
    }

    get trackLabel() {
      const heading = this.closest(".egc")?.querySelector(".egc_heading");
      return heading ? heading.textContent.trim() : "Explore gifts";
    }

    onKeydown(event) {
      if (!this.mobileQuery.matches) return;
      if (event.target !== this.track) return;
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;

      event.preventDefault();

      const step = this.items[0] ? this.items[0].getBoundingClientRect().width + 12 : 200;
      const direction = event.key === "ArrowRight" ? 1 : -1;
      const behavior = this.reducedMotionQuery.matches ? "auto" : "smooth";

      this.track.scrollBy({ left: step * direction, behavior });
    }
  }

  customElements.define("explore-gifts", ExploreGifts);
})();
